import { EventEmitter, Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { IArbetsorderAtgarder } from "~app/features/planera/model/IArbetsorderAtgarder";
import { IGetArbetsorderRequest } from "~app/features/planera/model/IGetArbetsorderRequest";

@Injectable({
    providedIn: "root"
})
// Denna service används för att prata med AngularJS-sidan "planera"
// Den är gjord med EventEmitters för jag är osäker på hur bra rxjs lirar i AngularJS
export class ArbetsorderSearchHybridService {

    clearFilters = new EventEmitter();
    filtersUpdated = new EventEmitter();
    searchArbetsordrar = new EventEmitter<IGetArbetsorderRequest>();
    setFilter = new BehaviorSubject<IGetArbetsorderRequest>(null);
    setMinaMaskinlagFilter = new EventEmitter<IGetArbetsorderRequest>();
    clearMinaMaskinlag = new EventEmitter<IGetArbetsorderRequest>();
    searchResultsUpdated = new EventEmitter<IArbetsorderAtgarder[]>();

    constructor() {
        // Tom konstruktor
    }

    triggerSetMinaMaskinlag() {
        this.setMinaMaskinlagFilter.emit();
    }

    triggerMinaMaskinlagClear() {
        this.clearMinaMaskinlag.emit();
    }

    triggerSetFilter(filter: IGetArbetsorderRequest) {
        this.setFilter.next(filter);
    }

    triggerClearFilters() {
        this.clearFilters.emit();
    }

    triggerSearchArbetsordrar(filter: IGetArbetsorderRequest) {
        this.searchArbetsordrar.emit(filter);
    }

    triggerFiltersUpdated() {
        this.filtersUpdated.emit();
    }

    triggerSearchResultsFound(arbetsorderList: IArbetsorderAtgarder[]) {
        this.searchResultsUpdated.emit(arbetsorderList);
    }

}
